import React from 'react';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import { digits } from '@this/src/util/price/price.util';
import TripDescriptionContent from './trip_description_content';
import { MarketLogContent } from './market_log_content';
import {
  type OrderItemDescriptionProps,
  formatTravelerText,
  SectionDescText,
  OutlineBox,
  SectionApplication,
  SectionApplicationInfo,
  SectionApplicationBox,
  SectionLabel,
  SectionMarket,
  SectionPrice,
  SectionBudgetHr
} from './shared';

const OrderItemDescription: React.FC<OrderItemDescriptionProps> = ({
  ticketStateType,
  trip,
  tripId,
  orderItem,
  changedPrice
}) => {
  const firstItem = orderItem.firstItem;
  const soldOut = orderItem.soldOut || ticketStateType === 'noFlight';
  const firstItemPrice = orderItem.firstItem?.price?.price || 0;
  const isPriceChanged = firstItemPrice !== changedPrice;

  return (
    <OutlineBox>
      <SectionApplicationBox>
        {orderItem.elements.map((el, j) => (
          <SectionApplication key={el.id}>
            <SectionLabel>
              <p data-wovn-ignore>{`【${el.title}】`}</p>
            </SectionLabel>

            <SectionApplicationInfo>
              <TripDescriptionContent
                el={el}
                firstEl={firstItem?.elements[j]}
                orderItem={orderItem}
                isPackage={orderItem.isPackage}
                flightPriceChangeDetail={orderItem.price.flightPriceChangeDetail || ''}
              />
              {trip.travelerInformations
                .filter(tst => tst.showRailwaySeat)
                .map((tst, i) => (
                  <TranslateIgnoreText key={tst.id} text={formatTravelerText(el, tst, i)} />
                ))}
              <SectionBudgetHr />
            </SectionApplicationInfo>

            <SectionMarket>
              <MarketLogContent tripId={tripId} el={el} />
            </SectionMarket>
          </SectionApplication>
        ))}

        <SectionApplication>
          <SectionLabel>
            <span />
          </SectionLabel>
          <SectionApplicationInfo>
            <SectionPrice>
              <span>{orderItem.orderItemCategoryText}</span>
              <span>
                <SectionDescText isOld={soldOut || isPriceChanged}>
                  <span data-wovn-ignore>{digits(firstItemPrice)}</span>
                  <span>円</span>
                </SectionDescText>
                {soldOut ? (
                  <SectionDescText isOld={false} className="red">
                    {ticketStateType === 'noFlight' ? '満席' : '売り切れ'}
                  </SectionDescText>
                ) : isPriceChanged ? (
                  <SectionDescText isOld={false} className="red">
                    <span data-wovn-ignore>{digits(changedPrice)}</span>
                    <span>円</span>
                  </SectionDescText>
                ) : null}
              </span>
            </SectionPrice>
            {orderItem.price.margin && orderItem.price.margin.amount === 0 && (
              <SectionPrice>
                <span>手数料</span>
                <span data-wovn-ignore>{digits(orderItem.price.margin.amount)}円</span>
              </SectionPrice>
            )}
          </SectionApplicationInfo>
          <SectionMarket>
            <span />
          </SectionMarket>
        </SectionApplication>
      </SectionApplicationBox>
    </OutlineBox>
  );
};

export default OrderItemDescription;
